export const DueDateConstants = {
  businessDayKey: "BusinessDay",
  businessDayFriendly: "Business Day(s)",
  calendarDayKey: "CalendarDay",
  calendarDayFriendly: "Calendar Day(s)"
};
